import React from "react";
import SuperAdminPerformanceReviews from "../superadmin/employees/PerformanceReviewsPage";

const PerformanceReviewsPage = () => {
    return <SuperAdminPerformanceReviews />;
};

export default PerformanceReviewsPage;
